import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-Feedback",
  "use": "svg-icon-Feedback-usage",
  "viewBox": "0 0 21 19",
  "content": "<symbol viewBox=\"0 0 21 19\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-Feedback\"><path d=\"M4 0h13a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-7l-5 3v-3H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm0 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm1.5 8a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol